import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { initialBookingForm } from "../actions/formAction";


const initialBookingState = {
    loading: 'idle',
    hasError: false,
    errorMessage: '',
    data: {
        bookingStatusList: [],
        portLoadingList: [],
        destinationList: [],
        shippingLineList: []
    }
};

const formInitialBookingSlice = createSlice({
    name: "initialBookingData",
    initialState: initialBookingState,
    reducers: {
        resetState: (state) => {
            state.loading = 'idle';
            state.hasError = false;
            state.errorMessage = '';
            state.data = {
                bookingStatusList: [],
                portLoadingList: [],
                destinationList: [],
                shippingLineList: []
            };
        }
    },
    extraReducers: (builder) => {
        builder

        .addCase(PURGE, () => {
            return initialBookingState;
        })
            .addCase(initialBookingForm.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
                state.errorMessage = '';

            })
            .addCase(initialBookingForm.fulfilled, (state, action) => {
                const response = action.payload;
                state.loading = 'succeeded';
                state.data = response;
                state.hasError = false;
                state.errorMessage = '';

            })
            .addCase(initialBookingForm.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload;
            });
    }
});

export const { resetState } = formInitialBookingSlice.actions;

export default formInitialBookingSlice.reducer;
